import Skeleton from "react-loading-skeleton";

import { cn } from "@bentolabs/kit/utils";

import { usePointsAccount } from "shared/api/use-points-account-query";
import WasabiLogo from "shared/assets/wasabi-logo.svg?react";

import { usePointsReward } from "./use-points-reward";

type Props = {
  className?: string;
};

const formatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
});

export const WasabiPointsCard = (props: Props) => {
  const { className } = props;
  const pointsAccountQuery = usePointsAccount();

  const rate = pointsAccountQuery.data?.totalPoints.rate ?? 0;
  const reward = usePointsReward(0, rate);
  const points = pointsAccountQuery.data?.totalPoints;

  if (pointsAccountQuery.isPending)
    return (
      <div
        className={cn(
          "relative flex flex-col overflow-hidden rounded-xl",
          className
        )}
      >
        <Skeleton width="100%" height={165} borderRadius={12} />
      </div>
    );

  return (
    <div
      className={cn(
        "bg-baltic-sea/30 relative flex w-full flex-col overflow-hidden rounded-xl",
        className
      )}
    >
      <div className="flex items-center bg-white/2 px-4 py-3.5">
        <div className="flex items-center gap-x-3">
          <div className="bg-spearmint flex size-8 items-center justify-center rounded-full">
            <WasabiLogo className="inline-flex size-6 text-black" />
          </div>

          <span className="text-lg text-white">WASABI Points</span>
        </div>
      </div>

      <div className="grid grid-cols-2 pt-5.5 pb-4.5 pl-5.5">
        <div className="flex flex-col gap-2">
          <div className="text-nobel/70">Total</div>
          <div className="text-3xl">{formatter.format(points?.value ?? 0)}</div>
        </div>
        <div className="flex flex-col gap-2">
          <div className="text-nobel/70">24 hour</div>
          <div className="text-3xl">{Math.floor(reward)}</div>
        </div>
      </div>
    </div>
  );
};
